import React from 'react';
import AppTitle from '../AppTitle';

const Shipping = () => {
  return (
    <div>
      <AppTitle title={'Shipping And Delivery'} from={'Home'} to='Contact' link='/' />

      <div className='container custom-container mt-10'>
        <div className='row gy-6'>
          <div className='col-12 '>
            <div className='contact-section1_content'>
              <h2 className='contact-section2__title'>Delivery Policy</h2>
              <p className='contact-section2__text' style={{ maxWidth: '100%' }}>
                We deliver across Bangalore. The cost is based on the distance and is calculated at
                the checkout based on your address.
                <br />
                <br />
                <b>Our delivery timings are as follows:</b>
                <br />
                <ol>
                  <li>
                    <b>First Batch:</b> 3:00 PM to 5:00 PM
                  </li>
                  <li>
                    <b>Second Batch:</b> 5:00 PM to 7:00 PM
                  </li>
                </ol>
                <br />
                Please ensure that someone is available to receive the delivery during the selected
                time frame. We will do our best to deliver your order within the specified time, but
                please note that delivery times may vary depending on traffic and other factors.
                <br />
                <br />
                If you have any special requests regarding delivery or need further assistance, feel
                free to contact us at{' '}
                <b>
                  <a
                    className='social-item'
                    href='mailto:saycheezecakes@gmail.com'
                    target='_blank'
                    rel='noopener'
                  >
                    saycheezecakes@gmail.com
                  </a>
                </b>{' '}
                or via WhatsApp at{' '}
                <b>
                  <a href='https://wa.me/919945423080'>+91 99454 23080</a>
                </b>
                <br />
                <br />
                {/* This version includes your delivery times and ensures your customers know the
                details for delivery slots. */}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Shipping;
